module.exports = __webpack_public_path__ + "media/images/views/candidate/request/greeting-33fa53451fe9c1b76f697b57f46cc18a.png";